<template>

    <div>

    <select v-model="handler" class="form-control" @change="change">
        <option value="inherit">{{_lang('default')}}</option>
        <option value="sans-serif">sans-serif</option>
        <option value="serif">serif</option>
        <option v-for="font in fonts" :value="font.family">{{font.family}}</option>
    </select>
    </div>

</template>

<script>

export default {
  props: ['config', 'name', 'value'],
  data(){
      return {
          handler:'inherit',
      }
  },
  computed:{
      fonts(){
          return this.$store.getters.fonts;
      }
  },
  mounted(){
    this.handler = this.value
  },
  methods:{
    change(){
        var newval = this.handler;
        this.$emit('change',newval);
    },

  }

}
</script>
